import { render, staticRenderFns } from "./request-prompt.vue?vue&type=template&id=354c60e2"
import script from "./request-prompt.vue?vue&type=script&lang=js"
export * from "./request-prompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports